import { render, staticRenderFns } from "./Addschedule.vue?vue&type=template&id=6ff9355e&"
import script from "./Addschedule.vue?vue&type=script&lang=js&"
export * from "./Addschedule.vue?vue&type=script&lang=js&"
import style0 from "./Addschedule.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports